import {
  ALERT_SET,
  GO_TO_STEP,
  MESSAGES_SET,
  OTHER_CONTENT,
  OTHER_CONTENT_FAILURE,
  OTHER_CONTENT_SUCCESS,
  PAYGATE_MESSAGES_SET,
  RESET_PARAMS,
  SET_DATA_TO_STEP,
  SET_STEP,
  SET_TICKET_ID,
} from './constants';

const stepperInitialState = {
  currentStep: 'firstWay',
  stepParams: {},
};

const stepperReducer = (state = stepperInitialState, action) => {
  switch (action.type) {
    case SET_STEP:
      return {
        ...state,
        currentStep: action.payload,
        stepParams: {
          ...state.stepParams,
          [action.data.for]: action.data.info,
        },
      };
    case GO_TO_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case RESET_PARAMS:
      return {
        ...state,
        stepParams: {},
      };
    case SET_DATA_TO_STEP:
      return {
        ...state,
        stepParams: {
          ...state.stepParams,
          [action.data.for]: action.data.info,
        },
      };
    default:
      return state;
  }
};

export const messagesReducer = (state = [], action) => {
  switch (action.type) {
    case MESSAGES_SET: {
      return action.payload.messages;
    }
    default:
      return state;
  }
};

export const paygateMessagesReducer = (state = [], action) => {
  switch (action.type) {
    case PAYGATE_MESSAGES_SET: {
      return action.payload.messages;
    }
    default:
      return state;
  }
};

const ticketIdInitialState = null;

export const ticketIdreducer = (state = ticketIdInitialState, action) => {
  switch (action.type) {
    case SET_TICKET_ID: {
      return action.payload;
    }
    default:
      return state;
  }
};

export const alertReducer = (state = { show: false, title: '' }, action) => {
  switch (action.type) {
    case ALERT_SET:
      return action.payload.configuration;
    default:
      return state;
  }
};

export const otherContentreducer = (state = {}, action) => {
  switch (action.type) {
    case OTHER_CONTENT: {
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          isFetching: true,
        },
      };
    }
    case OTHER_CONTENT_SUCCESS: {
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          data: {
            name: action.payload.name,
            body: action.payload.body,
          },
          isFetching: false,
        },
      };
    }
    case OTHER_CONTENT_FAILURE: {
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          isFetching: false,
        },
      };
    }
    default:
      return state;
  }
};

export default stepperReducer;



// WEBPACK FOOTER //
// ./src/containers/App/reducer.js